import { render, staticRenderFns } from "./EditSystem.vue?vue&type=template&id=6595b610&scoped=true"
import script from "./EditSystem.vue?vue&type=script&lang=js"
export * from "./EditSystem.vue?vue&type=script&lang=js"
import style0 from "./EditSystem.vue?vue&type=style&index=0&id=6595b610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6595b610",
  null
  
)

export default component.exports